import React, { useState, useEffect, useContext } from 'react';
import { db, storage, auth } from '../config/firebase';
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { AuthContext } from '../config/AuthProvider';
import Modal from 'react-modal';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';
import { FaDownload, FaEdit, FaTrash } from 'react-icons/fa';
import ReportModal from './ReportModal';
import Tooltip from './Tooltip';
import '../css/PersonRow.css';

function PersonRow({
  person,
  earningsData,
  numOfWeeks,
  startWeek,
  selectedYear,
  selectedMonth,
  selectedPeriod,
  userPeriodData,
  onDeletePerson,
  onUpdatePerson,
  refreshData,
  firms = [],
  selectedNationality,
  hiddenColumns = {
    riderID: false,
    grad: false,
    firma: false,
    nationality: false,
    zaradaTotal: false,
    fee: false,
    feeIznos: false,
    total1: false,
    appKnjig: false,
    doprinosi: false,
    renta: false,
    rentSmjestaj: false,
    tarifa: false,
    struja: false,
    glovoTax: false,
    akontacija: false,
    gorivo: false,
    ostalo: false,
    bonus: false,
    total2: false,
  },
}) {
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [isFinancialModalOpen, setIsFinancialModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isEarningsModalOpen, setIsEarningsModalOpen] = useState(false);

  const [startMonth, setStartMonth] = useState(person.startMonth || new Date().getMonth() + 1);
  const [startYear, setStartYear] = useState(person.startYear || new Date().getFullYear());
  const [isRowSelected, setIsRowSelected] = useState(false);

  const [name, setName] = useState(person.name);
  const [nationality, setNationality] = useState(person.nationality);
  const [city, setCity] = useState(person.city || '');
  const [comment, setComment] = useState(person.comment || '');
  const [tekuciRacun, setTekuciRacun] = useState(person.tekuciRacun || '');
  const [zasticeniRacun, setZasticeniRacun] = useState(person.zasticeniRacun || '');
  const [riderID, setRiderID] = useState(
    (userPeriodData.riderID || person.riderID || '').trim().toLowerCase()
  );
  const [firmId, setFirmId] = useState(person.firmId || 'default');
  const [email, setEmail] = useState(person.email || 'nema');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(person.imageUrl || null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const { currentUser } = useContext(AuthContext);

  const [appKnjigDefault, setAppKnjigDefault] = useState(person.appKnjig || 0);
  const [doprinosiDefault, setDoprinosiDefault] = useState(person.doprinosi || 0);
  const [feeDefault, setFeeDefault] = useState(person.fee || 0);

  const [fee, setFee] = useState(
    userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0
  );
  const [appKnjig, setAppKnjig] = useState(
    userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0
  );
  const [doprinosi, setDoprinosi] = useState(
    userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0
  );
  const [renta, setRenta] = useState(
    userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0
  );
  const [rentSmjestaj, setRentSmjestaj] = useState(
    userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0
  );
  const [oprema, setOprema] = useState(
    userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0
  );
  const [akontacija, setAkontacija] = useState(
    userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0
  );
  const [gorivo, setGorivo] = useState(
    userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0
  );
  const [ostalo, setOstalo] = useState(
    userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0
  );
  const [bonus, setBonus] = useState(
    userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0
  );
  const [tarifa, setTarifa] = useState(
    userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0
  );
  const [depozit, setDepozit] = useState(
    userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0
  );
  const [struja, setStruja] = useState(
    userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0
  );
  const [glovoTax, setGlovoTax] = useState(
    userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0
  );
  const [napomena, setNapomena] = useState(userPeriodData.napomena || '');

  const [rentaDefault, setRentaDefault] = useState(person.renta || 0);
  const [rentSmjestajDefault, setRentSmjestajDefault] = useState(person.rentSmjestaj || 0);
  const [opremaDefault, setOpremaDefault] = useState(person.oprema || 0);
  const [akontacijaDefault, setAkontacijaDefault] = useState(person.akontacija || 0);
  const [gorivoDefault, setGorivoDefault] = useState(person.gorivo || 0);
  const [ostaloDefault, setOstaloDefault] = useState(person.ostalo || 0);
  const [bonusDefault, setBonusDefault] = useState(person.bonus || 0);
  const [tarifaDefault, setTarifaDefault] = useState(person.tarifa || 0);
  const [depozitDefault, setDepozitDefault] = useState(person.depozit || 0);
  const [strujaDefault, setStrujaDefault] = useState(person.struja || 0);
  const [glovoTaxDefault, setGlovoTaxDefault] = useState(person.glovoTax || 0);

  const [earnings, setEarnings] = useState([]);
  const [woltEarnings, setWoltEarnings] = useState([0, 0]); // W1 i W2
  const [editedWeeks, setEditedWeeks] = useState(new Array(numOfWeeks).fill(false));
  const [editedWoltWeeks, setEditedWoltWeeks] = useState([false, false]); // Za W1 i W2
  const [feeAmount, setFeeAmount] = useState((0).toFixed(2));

  useEffect(() => {
    const earningsArray = new Array(numOfWeeks).fill(0);
    const woltArray = [0, 0]; // W1 i W2

    earningsData.forEach((earning) => {
      if (earning.userId === person.id &&
          earning.year === selectedYear &&
          earning.month === selectedMonth) {
        // Provjera je li to Wolt zarada
        const isWolt = earning.platform === 'wolt' || earning.week === 'w1' || earning.week === 'w2';
        
        if (isWolt) {
          // Wolt zarade - W1 ili W2
          if (earning.week === 'w1') {
            woltArray[0] = parseFloat(earning.amount) || 0;
          } else if (earning.week === 'w2') {
            woltArray[1] = parseFloat(earning.amount) || 0;
          }
        } else {
          // Glovo zarade - normalni tjedni
          let weekIndex = earning.week - startWeek;
          if (weekIndex >= 0 && weekIndex < numOfWeeks) {
            earningsArray[weekIndex] = parseFloat(earning.amount) || 0;
          }
        }
      }
    });

    setEarnings(earningsArray);
    setWoltEarnings(woltArray);
  }, [earningsData, person.id, numOfWeeks, startWeek, selectedYear, selectedMonth]);

  // ZaradaTotal uključuje i Glovo i Wolt zarade
  const glovoTotal = earnings.reduce((sum, earning) => sum + earning, 0);
  const woltTotal = woltEarnings.reduce((sum, earning) => sum + earning, 0);
  const zaradaTotal = glovoTotal + woltTotal;
  const calculatedFeeAmount = ((zaradaTotal * fee) / 100).toFixed(2);
  const total1 = (zaradaTotal - (zaradaTotal * fee) / 100).toFixed(2);
  const total2 = (
    zaradaTotal -
    (zaradaTotal * fee) / 100 -
    appKnjig -
    doprinosi -
    renta -
    rentSmjestaj -
    oprema -
    akontacija -
    gorivo -
    ostalo -
    (person.nationality === 'Stranac' ? tarifa + depozit + struja + glovoTax : 0) +
    bonus
  ).toFixed(2);

  useEffect(() => {
    setName(person.name);
    setNationality(person.nationality);
    setCity(person.city || '');
    setComment(person.comment || '');
    setTekuciRacun(person.tekuciRacun || '');
    setZasticeniRacun(person.zasticeniRacun || '');
    setRiderID((userPeriodData.riderID || person.riderID || '').trim().toLowerCase());
    setFirmId(person.firmId || 'default');
    setImagePreview(person.imageUrl || null);
    setImageFile(null);
    setRentaDefault(person.renta || 0);
    setRentSmjestajDefault(person.rentSmjestaj || 0);
    setOpremaDefault(person.oprema || 0);
    setAkontacijaDefault(person.akontacija || 0);
    setGorivoDefault(person.gorivo || 0);
    setOstaloDefault(person.ostalo || 0);
    setBonusDefault(person.bonus || 0);
    setAppKnjigDefault(person.appKnjig || 0);
    setDoprinosiDefault(person.doprinosi || 0);
    setFeeDefault(person.fee || 0);

    if (person.nationality === 'Stranac') {
      setTarifaDefault(person.tarifa || 0);
      setDepozitDefault(person.depozit || 0);
      setStrujaDefault(person.struja || 0);
      setGlovoTaxDefault(person.glovoTax || 0);
    }
  }, [person, userPeriodData]);

  useEffect(() => {
    setStartMonth(person.startMonth || new Date().getMonth() + 1);
    setStartYear(person.startYear || new Date().getFullYear());
    setFee(userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0);
    setAppKnjig(userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0);
    setDoprinosi(userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0);
    setRenta(userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0);
    setRentSmjestaj(userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0);
    setOprema(userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0);
    setAkontacija(userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0);
    setGorivo(userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0);
    setOstalo(userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0);
    setBonus(userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0);
    setNapomena(userPeriodData.napomena !== undefined ? userPeriodData.napomena : person.napomena || '');
    if (person.nationality === 'Stranac') {
      setTarifa(userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0);
      setDepozit(userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0);
      setStruja(userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0);
      setGlovoTax(userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0);
    }
  }, [userPeriodData, person]);

  useEffect(() => {
    setFeeAmount(calculatedFeeAmount);
  }, [zaradaTotal, fee]);

  const openReportModal = () => setIsReportModalOpen(true);
  const closeReportModal = () => setIsReportModalOpen(false);
  const openPersonModal = () => setIsPersonModalOpen(true);
  const closePersonModal = () => setIsPersonModalOpen(false);
  const openFinancialModal = () => setIsFinancialModalOpen(true);
  const closeFinancialModal = () => setIsFinancialModalOpen(false);
  const openEarningsModal = () => setIsEarningsModalOpen(true);
  const closeEarningsModal = () => {
    setEditedWeeks(new Array(numOfWeeks).fill(false));
    setEditedWoltWeeks([false, false]);
    setIsEarningsModalOpen(false);
  };

  const transferEarningsPeriod = async () => {
    try {
      const earningsQuery = query(
        collection(db, 'earnings'),
        where('userId', '==', person.id),
        where('week', 'in', [3, 4, 5]),
        where('period', '==', 1)
      );
      const earningsSnapshot = await getDocs(earningsQuery);
      const updatePromises = earningsSnapshot.docs.map((doc) =>
        updateDoc(doc.ref, { period: 2 })
      );
      await Promise.all(updatePromises);
      alert('Earnings periods successfully updated to 2');
    } catch (error) {
      console.error('Error updating earnings periods:', error);
      alert('Failed to update earnings periods.');
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Provjera tipa datoteke
      if (!file.type.startsWith('image/')) {
        alert('Molimo odaberite sliku.');
        return;
      }
      // Provjera veličine (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Slika je prevelika. Maksimalna veličina je 5MB.');
        return;
      }
      setImageFile(file);
      // Kreiranje preview-a
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Funkcija za sanitizaciju imena datoteke
  const sanitizeFileName = (fileName) => {
    // Ukloni sve posebne znakove osim slova, brojeva, točke i crtice
    return fileName.replace(/[^a-zA-Z0-9.-]/g, '_');
  };

  const handleSavePerson = async () => {
    try {
      const normalizedRiderID = riderID.trim().toLowerCase();
      if (normalizedRiderID !== (person.riderID || '').trim().toLowerCase()) {
        const riderIDQuery = query(
          collection(db, 'users'),
          where('riderID', '==', normalizedRiderID)
        );
        const riderIDSnapshot = await getDocs(riderIDQuery);
        if (!riderIDSnapshot.empty) {
          alert('Rider ID već postoji. Molimo unesite jedinstveni Rider ID.');
          return;
        }
      }

      if (person.nationality === 'Stranac' && nationality === 'Hrvat') {
        await transferEarningsPeriod();
      }

      let imageUrl = person.imageUrl || null;

      // Upload nove slike ako postoji
      if (imageFile) {
        // Provjera autentifikacije
        if (!currentUser) {
          alert('Morate biti prijavljeni da biste uploadali sliku.');
          return;
        }

        setUploadingImage(true);
        try {
          // Sanitiziraj ime datoteke
          const sanitizedFileName = sanitizeFileName(imageFile.name);
          const imageRef = ref(storage, `person-images/${person.id}-${Date.now()}-${sanitizedFileName}`);
          
          // Upload nove slike (stara će ostati u storage-u, ali se neće koristiti)
          await uploadBytes(imageRef, imageFile);
          imageUrl = await getDownloadURL(imageRef);
        } catch (error) {
          console.error('Greška pri upload-u slike:', error);
          console.error('Error details:', error.code, error.message);
          
          let errorMessage = 'Došlo je do greške prilikom upload-a slike.';
          if (error.code === 'storage/unauthorized') {
            errorMessage = 'Nemate dozvolu za upload slike. Provjerite Firebase Storage rules.';
          } else if (error.code === 'storage/canceled') {
            errorMessage = 'Upload je otkazan.';
          } else if (error.code === 'storage/unknown') {
            errorMessage = 'Nepoznata greška. Provjerite da li je Storage omogućen u Firebase Console.';
          }
          
          alert(errorMessage);
          setUploadingImage(false);
          return;
        }
        setUploadingImage(false);
      }

      const updatedPerson = {
        ...person,
        name,
        nationality,
        city,
        comment,
        tekuciRacun,
        zasticeniRacun,
        riderID: normalizedRiderID,
        firmId,
        email: email,
        appKnjig: appKnjigDefault,
        doprinosi: doprinosiDefault,
        fee: feeDefault,
        renta: rentaDefault,
        rentSmjestaj: rentSmjestajDefault,
        oprema: opremaDefault,
        akontacija: akontacijaDefault,
        gorivo: gorivoDefault,
        ostalo: ostaloDefault,
        bonus: bonusDefault,
        startMonth,
        startYear,
      };

      // Dodaj imageURL ako postoji
      if (imageUrl) {
        updatedPerson.imageUrl = imageUrl;
      }

      if (nationality === 'Stranac') {
        updatedPerson.tarifa = tarifaDefault;
        updatedPerson.depozit = depozitDefault;
        updatedPerson.struja = strujaDefault;
        updatedPerson.glovoTax = glovoTaxDefault;
      } else {
        delete updatedPerson.tarifa;
        delete updatedPerson.depozit;
        delete updatedPerson.struja;
        delete updatedPerson.glovoTax;
      }

      await updateDoc(doc(db, 'users', person.id), updatedPerson);
      onUpdatePerson(updatedPerson);
      closePersonModal();
      alert('Promjene osnove osobe su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju korisnika:', e);
      alert('Došlo je do greške prilikom spremanja promjena. Pokušajte ponovno.');
    }
  };

  const handleSaveFinancial = async () => {
    try {
      const userPeriodQuery = query(
        collection(db, 'userPeriodData'),
        where('userId', '==', person.id),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth),
        where('period', '==', selectedPeriod)
      );
      const userPeriodSnapshot = await getDocs(userPeriodQuery);

      const dataToSave = {
        fee,
        appKnjig,
        doprinosi,
        renta,
        rentSmjestaj,
        oprema,
        akontacija,
        gorivo,
        ostalo,
        bonus,
        napomena,
        zaradaTotal: zaradaTotal.toFixed(2),
        feeAmount: feeAmount,
        total1: total1,
        total2: total2,
      };

      if (person.nationality === 'Stranac') {
        dataToSave.tarifa = tarifa;
        dataToSave.depozit = depozit;
        dataToSave.struja = struja;
        dataToSave.glovoTax = glovoTax;
      } else {
        dataToSave.tarifa = 0;
        dataToSave.depozit = 0;
        dataToSave.struja = 0;
        dataToSave.glovoTax = 0;
      }

      if (!userPeriodSnapshot.empty) {
        const docRef = userPeriodSnapshot.docs[0].ref;
        await updateDoc(docRef, dataToSave);
      } else {
        dataToSave.userId = person.id;
        dataToSave.year = selectedYear;
        dataToSave.month = selectedMonth;
        dataToSave.period = selectedPeriod;
        await addDoc(collection(db, 'userPeriodData'), dataToSave);
      }

      refreshData();
      closeFinancialModal();
      alert('Financijske promjene su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju financijskih podataka:', e);
      alert('Došlo je do greške prilikom spremanja financijskih promjena. Pokušajte ponovno.');
    }
  };

  const handleSaveEarnings = async () => {
    try {
      // Spremanje Glovo zarada (normalni tjedni)
      for (let i = 0; i < earnings.length; i++) {
        if (!editedWeeks[i]) continue;

        const weekNumber = startWeek + i;
        const amount = earnings[i];

        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          await updateDoc(earningsDocRef, {
            amount: amount,
            period: selectedPeriod,
          });
        } else if (amount !== 0) {
          await addDoc(collection(db, 'earnings'), {
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: weekNumber,
            amount: amount,
            firmId: person.firmId,
            period: selectedPeriod,
          });
        }
      }

      // Spremanje Wolt zarada (W1 i W2)
      for (let i = 0; i < woltEarnings.length; i++) {
        if (!editedWoltWeeks[i]) continue;

        const woltWeek = i === 0 ? 'w1' : 'w2'; // w1 ili w2
        const amount = woltEarnings[i];

        const woltEarningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', woltWeek),
          where('platform', '==', 'wolt')
        );

        const woltEarningsSnapshot = await getDocs(woltEarningsQuery);

        if (!woltEarningsSnapshot.empty) {
          const earningsDocRef = woltEarningsSnapshot.docs[0].ref;
          await updateDoc(earningsDocRef, {
            amount: amount,
            period: selectedPeriod,
          });
        } else if (amount !== 0) {
          await addDoc(collection(db, 'earnings'), {
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: woltWeek,
            amount: amount,
            firmId: person.firmId,
            period: selectedPeriod,
            platform: 'wolt', // Označavamo da je to Wolt zarada
          });
        }
      }

      refreshData();
      setEditedWeeks(new Array(numOfWeeks).fill(false));
      setEditedWoltWeeks([false, false]);
      closeEarningsModal();
      alert('Zarade po tjednima su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri spremanju zarada:', e);
      alert('Došlo je do greške prilikom spremanja zarada. Pokušajte ponovno.');
    }
  };

  const handleDeleteEarning = async (weekIndex) => {
    if (window.confirm(`Jeste li sigurni da želite obrisati zaradu za tjedan ${startWeek + weekIndex}?`)) {
      try {
        const weekNumber = startWeek + weekIndex;
        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          await deleteDoc(earningsDocRef);

          const updatedEarnings = [...earnings];
          updatedEarnings[weekIndex] = 0;
          setEarnings(updatedEarnings);

          const updatedEditedWeeks = [...editedWeeks];
          updatedEditedWeeks[weekIndex] = false;
          setEditedWeeks(updatedEditedWeeks);

          refreshData();
          alert(`Zarada za tjedan ${weekNumber} je uspješno obrisana!`);
        } else {
          alert(`Nema zarade za tjedan ${weekNumber} za brisanje.`);
        }
      } catch (e) {
        console.error('Greška pri brisanju zarade:', e);
        alert('Došlo je do greške prilikom brisanja zarade. Pokušajte ponovno.');
      }
    }
  };

  const handleDeleteWoltEarning = async (woltIndex) => {
    const woltWeek = woltIndex === 0 ? 'W1' : 'W2';
    if (window.confirm(`Jeste li sigurni da želite obrisati Wolt zaradu za ${woltWeek}?`)) {
      try {
        const woltWeekKey = woltIndex === 0 ? 'w1' : 'w2';
        const woltEarningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', woltWeekKey),
          where('platform', '==', 'wolt')
        );

        const woltEarningsSnapshot = await getDocs(woltEarningsQuery);

        if (!woltEarningsSnapshot.empty) {
          const earningsDocRef = woltEarningsSnapshot.docs[0].ref;
          await deleteDoc(earningsDocRef);

          const updatedWoltEarnings = [...woltEarnings];
          updatedWoltEarnings[woltIndex] = 0;
          setWoltEarnings(updatedWoltEarnings);

          const updatedEditedWoltWeeks = [...editedWoltWeeks];
          updatedEditedWoltWeeks[woltIndex] = false;
          setEditedWoltWeeks(updatedEditedWoltWeeks);

          refreshData();
          alert(`Wolt zarada za ${woltWeek} je uspješno obrisana!`);
        } else {
          alert(`Nema Wolt zarade za ${woltWeek} za brisanje.`);
        }
      } catch (e) {
        console.error('Greška pri brisanju Wolt zarade:', e);
        alert('Došlo je do greške prilikom brisanja Wolt zarade. Pokušajte ponovno.');
      }
    }
  };

  const handleDeleteFinancialData = async () => {
    if (window.confirm('Jeste li sigurni da želite resetirati financijske podatke na zadane vrijednosti?')) {
      try {
        const userPeriodQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('period', '==', selectedPeriod)
        );
        const userPeriodSnapshot = await getDocs(userPeriodQuery);

        if (!userPeriodSnapshot.empty) {
          const docRef = userPeriodSnapshot.docs[0].ref;
          await deleteDoc(docRef);
          setFee(person.fee || 0);
          setAppKnjig(person.appKnjig || 0);
          setDoprinosi(person.doprinosi || 0);
          setRenta(person.renta || 0);
          setRentSmjestaj(person.rentSmjestaj || 0);
          setOprema(person.oprema || 0);
          setAkontacija(person.akontacija || 0);
          setGorivo(person.gorivo || 0);
          setOstalo(person.ostalo || 0);
          setBonus(person.bonus || 0);
          setNapomena('');
          alert('Financijski podaci su resetirani na zadane vrijednosti.');
          refreshData();
        } else {
          alert('Nema financijskih podataka za brisanje.');
        }
      } catch (e) {
        console.error('Greška pri brisanju financijskih podataka:', e);
        alert('Došlo je do greške prilikom brisanja financijskih podataka. Pokušajte ponovno.');
      }
    }
  };

  const handleDelete = async () => {
    if (window.confirm(`Jeste li sigurni da želite obrisati ${person.name}?`)) {
      try {
        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id)
        );
        const earningsSnapshot = await getDocs(earningsQuery);
        const deleteEarningsPromises = earningsSnapshot.docs.map((docSnap) =>
          deleteDoc(doc(db, 'earnings', docSnap.id))
        );
        await Promise.all(deleteEarningsPromises);

        const periodDataQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id)
        );
        const periodDataSnapshot = await getDocs(periodDataQuery);
        const deletePeriodDataPromises = periodDataSnapshot.docs.map((docSnap) =>
          deleteDoc(doc(db, 'userPeriodData', docSnap.id))
        );
        await Promise.all(deletePeriodDataPromises);

        await deleteDoc(doc(db, 'users', person.id));
        onDeletePerson(person.id);
        closePersonModal();
        closeFinancialModal();
        alert('Korisnik je uspješno izbrisan!');
      } catch (e) {
        console.error('Greška pri brisanju korisnika:', e);
        alert('Došlo je do greške prilikom brisanja korisnika. Pokušajte ponovno.');
      }
    }
  };

  const handleEarningChange = (e, weekIndex) => {
    const newAmount = parseFloat(e.target.value) || 0;
    const updatedEarnings = [...earnings];
    updatedEarnings[weekIndex] = newAmount;
    setEarnings(updatedEarnings);

    const updatedEditedWeeks = [...editedWeeks];
    updatedEditedWeeks[weekIndex] = true;
    setEditedWeeks(updatedEditedWeeks);
  };

  const handleWoltEarningChange = (e, woltIndex) => {
    const newAmount = parseFloat(e.target.value) || 0;
    const updatedWoltEarnings = [...woltEarnings];
    updatedWoltEarnings[woltIndex] = newAmount;
    setWoltEarnings(updatedWoltEarnings);

    const updatedEditedWoltWeeks = [...editedWoltWeeks];
    updatedEditedWoltWeeks[woltIndex] = true;
    setEditedWoltWeeks(updatedEditedWoltWeeks);
  };

  const getFirmName = (firmId) => {
    const firm = firms.find((firm) => firm.id === firmId);
    return firm ? firm.name : 'N/A';
  };

  const downloadExcelReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportData = [
      { header: 'Grad', value: person.city || 'N/A' },
      { header: 'Godina', value: selectedYear },
      { header: 'Mjesec', value: selectedMonth },
      { header: 'Period', value: selectedPeriod },
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `Tjedan ${startWeek + i}`,
        value: parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
      })),
      { header: 'W1', value: parseFloat((woltEarnings[0] || 0).toFixed(2)) },
      { header: 'W2', value: parseFloat((woltEarnings[1] || 0).toFixed(2)) },
      { header: '=', value: parseFloat(zaradaTotal.toFixed(2)) },
      { header: 'FEE', value: parseFloat(fee.toFixed(2)) },
      { header: 'Total 1', value: parseFloat(total1) },
      { header: 'App Knjig', value: parseFloat(appKnjig.toFixed(2)) },
      { header: 'Doprinosi', value: parseFloat(doprinosi.toFixed(2)) },
      { header: 'Renta', value: parseFloat(renta.toFixed(2)) },
      { header: 'Rent Smještaj', value: parseFloat(rentSmjestaj.toFixed(2)) },
      { header: 'Oprema', value: parseFloat(oprema.toFixed(2)) },
      { header: 'Akontacija', value: parseFloat(akontacija.toFixed(2)) },
      { header: 'Gorivo', value: parseFloat(gorivo.toFixed(2)) },
      { header: 'Ostalo', value: parseFloat(ostalo.toFixed(2)) },
      { header: 'Bonus', value: parseFloat(bonus.toFixed(2)) },
      { header: 'Tarifa', value: parseFloat(tarifa.toFixed(2)) },
      { header: 'Struja', value: parseFloat(struja.toFixed(2)) },
      { header: 'O.T.', value: parseFloat(glovoTax.toFixed(2)) },
      { header: 'Deposit', value: parseFloat(depozit.toFixed(2)) },
      { header: '', value: parseFloat(total2) },
    ];

    reportData.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}.xlsx`
    );
  };

  const downloadExcelReportEN = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportDataEN = [
      { header: 'City', value: person.city || 'N/A' },
      { header: 'Year', value: selectedYear },
      { header: 'Month', value: selectedMonth },
      { header: 'Period', value: selectedPeriod },
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `Week ${startWeek + i}`,
        value: parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
      })),
      { header: 'W1', value: parseFloat((woltEarnings[0] || 0).toFixed(2)) },
      { header: 'W2', value: parseFloat((woltEarnings[1] || 0).toFixed(2)) },
      { header: '=', value: parseFloat(zaradaTotal.toFixed(2)) },
      { header: 'FEE', value: parseFloat(fee.toFixed(2)) },
      { header: 'Total 1', value: parseFloat(total1) },
      { header: 'App Knjig', value: parseFloat(appKnjig.toFixed(2)) },
      { header: 'Contributions', value: parseFloat(doprinosi.toFixed(2)) },
      { header: 'Renta', value: parseFloat(renta.toFixed(2)) },
      { header: 'Rent Accommodation', value: parseFloat(rentSmjestaj.toFixed(2)) },
      { header: 'Equipment', value: parseFloat(oprema.toFixed(2)) },
      { header: 'Advance Payment', value: parseFloat(akontacija.toFixed(2)) },
      { header: 'Fuel', value: parseFloat(gorivo.toFixed(2)) },
      { header: 'Others', value: parseFloat(ostalo.toFixed(2)) },
      { header: 'Bonus', value: parseFloat(bonus.toFixed(2)) },
      { header: 'Tariff', value: parseFloat(tarifa.toFixed(2)) },
      { header: 'Electricity', value: parseFloat(struja.toFixed(2)) },
      { header: 'O.T.', value: parseFloat(glovoTax.toFixed(2)) },
      { header: 'Deposit', value: parseFloat(depozit.toFixed(2)) },
      { header: '', value: parseFloat(total2) },
    ];

    reportDataEN.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}_EN.xlsx`
    );
  };

  const downloadPDFReport = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportData = [
      ['Grad', person.city || 'N/A'],
      ['Godina', selectedYear],
      ['Mjesec', selectedMonth],
      ['Period', selectedPeriod],
      ...Array.from({ length: numOfWeeks }, (_, i) => [
        `Tjedan ${startWeek + i}`,
        parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
      ]),
      ['W1', parseFloat((woltEarnings[0] || 0).toFixed(2))],
      ['W2', parseFloat((woltEarnings[1] || 0).toFixed(2))],
      ['=', parseFloat(zaradaTotal.toFixed(2))],
      ['FEE', parseFloat(fee.toFixed(2))],
      ['Total 1', parseFloat(total1)],
      ['App Knjig', parseFloat(appKnjig.toFixed(2))],
      ['Doprinosi', parseFloat(doprinosi.toFixed(2))],
      ['Renta', parseFloat(renta.toFixed(2))],
      ['Rent Smještaj', parseFloat(rentSmjestaj.toFixed(2))],
      ['Oprema', parseFloat(oprema.toFixed(2))],
      ['Akontacija', parseFloat(akontacija.toFixed(2))],
      ['Gorivo', parseFloat(gorivo.toFixed(2))],
      ['Ostalo', parseFloat(ostalo.toFixed(2))],
      ['Bonus', parseFloat(bonus.toFixed(2))],
      ['Tarifa', parseFloat(tarifa.toFixed(2))],
      ['Struja', parseFloat(struja.toFixed(2))],
      ['O.T.', parseFloat(glovoTax.toFixed(2))],
      ['Deposit', parseFloat(depozit.toFixed(2))],
      ['', parseFloat(total2)],
    ];

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportData,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}.pdf`);
  };

  const downloadPDFReportEN = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportDataEN = [
      ['City', person.city || 'N/A'],
      ['Year', selectedYear],
      ['Month', selectedMonth],
      ['Period', selectedPeriod],
      ...Array.from({ length: numOfWeeks }, (_, i) => [
        `Week ${startWeek + i}`,
        parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
      ]),
      ['W1', parseFloat((woltEarnings[0] || 0).toFixed(2))],
      ['W2', parseFloat((woltEarnings[1] || 0).toFixed(2))],
      ['=', parseFloat(zaradaTotal.toFixed(2))],
      ['FEE', parseFloat(fee.toFixed(2))],
      ['Total 1', parseFloat(total1)],
      ['App Knjig', parseFloat(appKnjig.toFixed(2))],
      ['Contributions', parseFloat(doprinosi.toFixed(2))],
      ['Renta', parseFloat(renta.toFixed(2))],
      ['Rent Accommodation', parseFloat(rentSmjestaj.toFixed(2))],
      ['Equipment', parseFloat(oprema.toFixed(2))],
      ['Advance Payment', parseFloat(akontacija.toFixed(2))],
      ['Fuel', parseFloat(gorivo.toFixed(2))],
      ['Others', parseFloat(ostalo.toFixed(2))],
      ['Bonus', parseFloat(bonus.toFixed(2))],
      ['Tariff', parseFloat(tarifa.toFixed(2))],
      ['Electricity', parseFloat(struja.toFixed(2))],
      ['O.T.', parseFloat(glovoTax.toFixed(2))],
      ['Deposit', parseFloat(depozit.toFixed(2))],
      ['', parseFloat(total2)],
    ];

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportDataEN,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}_EN.pdf`);
  };

  const printReport = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${[
              ['Grad', person.city || 'N/A'],
              ['Godina', selectedYear],
              ['Mjesec', selectedMonth],
              ['Period', selectedPeriod],
              ...Array.from({ length: numOfWeeks }, (_, i) => [
                `Tjedan ${startWeek + i}`,
                parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
              ]),
              ['W1', parseFloat((woltEarnings[0] || 0).toFixed(2))],
              ['W2', parseFloat((woltEarnings[1] || 0).toFixed(2))],
              ['=', parseFloat(zaradaTotal.toFixed(2))],
              ['FEE', parseFloat(fee.toFixed(2))],
              ['Total 1', parseFloat(total1)],
              ['App Knjig', parseFloat(appKnjig.toFixed(2))],
              ['Doprinosi', parseFloat(doprinosi.toFixed(2))],
              ['Renta', parseFloat(renta.toFixed(2))],
              ['Rent Smještaj', parseFloat(rentSmjestaj.toFixed(2))],
              ['Oprema', parseFloat(oprema.toFixed(2))],
              ['Akontacija', parseFloat(akontacija.toFixed(2))],
              ['Gorivo', parseFloat(gorivo.toFixed(2))],
              ['Ostalo', parseFloat(ostalo.toFixed(2))],
              ['Bonus', parseFloat(bonus.toFixed(2))],
              ['Tarifa', parseFloat(tarifa.toFixed(2))],
              ['Struja', parseFloat(struja.toFixed(2))],
              ['O.T.', parseFloat(glovoTax.toFixed(2))],
              ['Deposit', parseFloat(depozit.toFixed(2))],
              ['', parseFloat(total2)],
            ].map(row => `<tr><td>${row[0]}</td><td>${typeof row[1] === 'number' ? row[1].toFixed(2) : row[1]}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const printReportEN = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${[
              ['City', person.city || 'N/A'],
              ['Year', selectedYear],
              ['Month', selectedMonth],
              ['Period', selectedPeriod],
              ...Array.from({ length: numOfWeeks }, (_, i) => [
                `Week ${startWeek + i}`,
                parseFloat((earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0).toFixed(2)),
              ]),
              ['W1', parseFloat((woltEarnings[0] || 0).toFixed(2))],
              ['W2', parseFloat((woltEarnings[1] || 0).toFixed(2))],
              ['=', parseFloat(zaradaTotal.toFixed(2))],
              ['FEE', parseFloat(fee.toFixed(2))],
              ['Total 1', parseFloat(total1)],
              ['App Knjig', parseFloat(appKnjig.toFixed(2))],
              ['Contributions', parseFloat(doprinosi.toFixed(2))],
              ['Renta', parseFloat(renta.toFixed(2))],
              ['Rent Accommodation', parseFloat(rentSmjestaj.toFixed(2))],
              ['Equipment', parseFloat(oprema.toFixed(2))],
              ['Advance Payment', parseFloat(akontacija.toFixed(2))],
              ['Fuel', parseFloat(gorivo.toFixed(2))],
              ['Others', parseFloat(ostalo.toFixed(2))],
              ['Bonus', parseFloat(bonus.toFixed(2))],
              ['Tariff', parseFloat(tarifa.toFixed(2))],
              ['Electricity', parseFloat(struja.toFixed(2))],
              ['O.T.', parseFloat(glovoTax.toFixed(2))],
              ['Deposit', parseFloat(depozit.toFixed(2))],
              ['', parseFloat(total2)],
            ].map(row => `<tr><td>${row[0]}</td><td>${typeof row[1] === 'number' ? row[1].toFixed(2) : row[1]}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleReportOption = async (format) => {
    console.log(format);
    let language = 'hr';
    if (format.endsWith('-en')) {
      language = 'en';
      format = format.slice(0, -3);
    }

    switch (format) {
      case 'xlsx':
        if (language === 'hr') await downloadExcelReport();
        else if (language === 'en') await downloadExcelReportEN();
        break;
      case 'pdf':
        if (language === 'hr') downloadPDFReport();
        else if (language === 'en') downloadPDFReportEN();
        break;
      case 'print':
        if (language === 'hr') printReport();
        else if (language === 'en') printReportEN();
        break;
      default:
        break;
    }
  };

  const handleArchive = async () => {
    if (window.confirm(`Jeste li sigurni da želite arhivirati ${person.name}?`)) {
      try {
        const archiveMonth = selectedMonth;
        const archiveYear = selectedYear;
        await updateDoc(doc(db, 'users', person.id), {
          archived: true,
          archiveMonth,
          archiveYear,
        });
        onUpdatePerson({ ...person, archived: true, archiveMonth, archiveYear });
        closePersonModal();
        closeFinancialModal();
        alert('Osoba uspješno arhivirana!');
      } catch (e) {
        console.error('Greška pri arhiviranju korisnika:', e);
        alert('Došlo je do greške prilikom arhiviranja korisnika. Pokušajte ponovno.');
      }
    }
  };

  return (
    <>
      <tr>
        <td className={isRowSelected ? 'selected-cell' : ''} onClick={() => setIsRowSelected(!isRowSelected)}>
          <Tooltip content={person.comment || ''} imageUrl={person.imageUrl || null}>
            {person.name}
          </Tooltip>
        </td>
        <td className={isRowSelected ? 'selected-cell' : ''}>
          <button className="edit-button" onClick={openReportModal} title="Report">
            <FaDownload /> Izvještaj
          </button>
          <button className="edit-button" onClick={openPersonModal} title="Uredi osobu">
            <FaEdit /> Osoba
          </button>
          <button className="edit-button" onClick={openFinancialModal} title="Uredi financije">
            <FaEdit /> Finan
          </button>
        </td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.riderID ? 'hidden-column' : ''}`}>{person.riderID}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.grad ? 'hidden-column' : ''}`}>{person.city || 'N/A'}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.firma ? 'hidden-column' : ''}`}>{getFirmName(person.firmId)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.nationality ? 'hidden-column' : ''}`}>{person.nationality === 'Hrvat' ? 'H' : 'S'}</td>
        {earnings.map((earning, index) => (
          <td className={isRowSelected ? 'selected-cell' : ''} key={index}>{earning.toFixed(2)}</td>
        ))}
        {/* W1 i W2 stupci */}
        <td className={isRowSelected ? 'selected-cell' : ''}>{woltEarnings[0].toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{woltEarnings[1].toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.zaradaTotal ? 'hidden-column' : ''}`}>{zaradaTotal.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.fee ? 'hidden-column' : ''}`}>{fee}%</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.feeIznos ? 'hidden-column' : ''}`}>{feeAmount}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.total1 ? 'hidden-column' : ''}`}>{total1}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.appKnjig ? 'hidden-column' : ''}`}>{appKnjig.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.doprinosi ? 'hidden-column' : ''}`}>{doprinosi.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.renta ? 'hidden-column' : ''}`}>{renta.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.rentSmjestaj ? 'hidden-column' : ''}`}>{rentSmjestaj.toFixed(2)}</td>
        <>
          <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.tarifa ? 'hidden-column' : ''}`}>{tarifa.toFixed(2)}</td>
          <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.struja ? 'hidden-column' : ''}`}>{struja.toFixed(2)}</td>
          <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.glovoTax ? 'hidden-column' : ''}`}>{glovoTax.toFixed(2)}</td>
        </>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.akontacija ? 'hidden-column' : ''}`}>{akontacija.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.gorivo ? 'hidden-column' : ''}`}>{gorivo.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.ostalo ? 'hidden-column' : ''}`}>{ostalo.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.bonus ? 'hidden-column' : ''}`}>{bonus.toFixed(2)}</td>
        <td className={`${isRowSelected ? 'selected-cell' : ''} ${hiddenColumns.total2 ? 'hidden-column' : ''}`}>{total2}</td>
      </tr>

      <ReportModal 
        isOpen={isReportModalOpen} 
        onRequestClose={closeReportModal} 
        onGenerateReport={handleReportOption} 
      />

      <Modal
        isOpen={isPersonModalOpen}
        onRequestClose={closePersonModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi osobu</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Ime:</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Grad:</label>
            <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Komentar:</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="3"
              placeholder="Komentar o osobi"
            />
          </div>
          <div className="form-group">
            <label>Slika osobe:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
            {imagePreview && (
              <div style={{ marginTop: '10px' }}>
                <img 
                  src={imagePreview} 
                  alt="Preview" 
                  style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '4px' }} 
                />
              </div>
            )}
            {uploadingImage && <p>Upload slike u tijeku...</p>}
          </div>
          <div className="form-group">
            <label>Nacionalnost:</label>
            <select value={nationality} onChange={(e) => setNationality(e.target.value)}>
              <option value="Hrvat">Hrvat</option>
              <option value="Stranac">Stranac</option>
            </select>
          </div>
          <div className="form-group">
            <label>Rider ID:</label>
            <input type="text" value={riderID} onChange={(e) => setRiderID(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Firma:</label>
            <select value={firmId} onChange={(e) => setFirmId(e.target.value)} required>
              <option value="default">Default</option>
              {firms.filter((firm) => firm.id !== 'default').map((firm) => (
                <option key={firm.id} value={firm.id}>{firm.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Tekući račun:</label>
            <input type="text" value={tekuciRacun} onChange={(e) => setTekuciRacun(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Zaštićeni račun:</label>
            <input type="text" value={zasticeniRacun} onChange={(e) => setZasticeniRacun(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Početni mjesec rada:</label>
            <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Početna godina rada:</label>
            <select value={startYear} onChange={(e) => setStartYear(parseInt(e.target.value))}>
              {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>App Knjig. (default):</label>
            <input
              type="number"
              value={appKnjigDefault}
              onChange={(e) => setAppKnjigDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Doprinosi (default):</label>
            <input
              type="number"
              value={doprinosiDefault}
              onChange={(e) => setDoprinosiDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Fee % (default):</label>
            <input
              type="number"
              value={feeDefault}
              onChange={(e) => setFeeDefault(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>Renta (default):</label>
            <input
              type="number"
              value={rentaDefault}
              onChange={(e) => setRentaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent smještaj (default):</label>
            <input
              type="number"
              value={rentSmjestajDefault}
              onChange={(e) => setRentSmjestajDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Akontacija (default):</label>
            <input
              type="number"
              value={akontacijaDefault}
              onChange={(e) => setAkontacijaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Gorivo (default):</label>
            <input
              type="number"
              value={gorivoDefault}
              onChange={(e) => setGorivoDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo (default):</label>
            <input
              type="number"
              value={ostaloDefault}
              onChange={(e) => setOstaloDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus (default):</label>
            <input
              type="number"
              value={bonusDefault}
              onChange={(e) => setBonusDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          {nationality === 'Stranac' && (
            <>
              <div className="form-group">
                <label>Tarifa (default):</label>
                <input
                  type="number"
                  value={tarifaDefault}
                  onChange={(e) => setTarifaDefault(parseFloat(e.target.value) || 0)}
                />
              </div>
              
              <div className="form-group">
                <label>Struja (default):</label>
                <input
                  type="number"
                  value={strujaDefault}
                  onChange={(e) => setStrujaDefault(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Overtime Tax (default):</label>
                <input
                  type="number"
                  value={glovoTaxDefault}
                  onChange={(e) => setGlovoTaxDefault(parseFloat(e.target.value) || 0)}
                />
              </div>
            </>
          )}
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSavePerson}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closePersonModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleArchive}>Arhiviraj</button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isFinancialModalOpen}
        onRequestClose={closeFinancialModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi financijske podatke</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Fee %:</label>
            <input
              type="number"
              value={fee}
              onChange={(e) => setFee(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>App Knjig.:</label>
            <input
              type="number"
              value={appKnjig}
              onChange={(e) => setAppKnjig(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Doprinosi:</label>
            <input
              type="number"
              value={doprinosi}
              onChange={(e) => setDoprinosi(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Renta:</label>
            <input
              type="number"
              value={renta}
              onChange={(e) => setRenta(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent smještaj:</label>
            <input
              type="number"
              value={rentSmjestaj}
              onChange={(e) => setRentSmjestaj(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Akontacija:</label>
            <input
              type="number"
              value={akontacija}
              onChange={(e) => setAkontacija(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Gorivo:</label>
            <input
              type="number"
              value={gorivo}
              onChange={(e) => setGorivo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo:</label>
            <input
              type="number"
              value={ostalo}
              onChange={(e) => setOstalo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus:</label>
            <input
              type="number"
              value={bonus}
              onChange={(e) => setBonus(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Napomena:</label>
            <input
              type="text"
              value={napomena}
              onChange={(e) => setNapomena(e.target.value)}
            />
          </div>
          {person.nationality === 'Stranac' && (
            <>
              <div className="form-group">
                <label>Tarifa:</label>
                <input
                  type="number"
                  value={tarifa}
                  onChange={(e) => setTarifa(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Struja:</label>
                <input
                  type="number"
                  value={struja}
                  onChange={(e) => setStruja(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Overtime Tax:</label>
                <input
                  type="number"
                  value={glovoTax}
                  onChange={(e) => setGlovoTax(parseFloat(e.target.value) || 0)}
                />
              </div>
            </>
          )}
          <div className="form-group">
            <button type="button" className="edit-button" onClick={openEarningsModal} title="Uredi zarade">
              <FaEdit /> Uredi zarade po tjednima
            </button>
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveFinancial}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeFinancialModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleDeleteFinancialData}>
              Resetiraj na zadane vrijednosti
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEarningsModalOpen}
        onRequestClose={closeEarningsModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi zarade po tjednima</h2>
        <form className="edit-person-form">
          <h3 style={{ marginBottom: '15px', color: '#667eea' }}>Glovo zarade</h3>
          {[...Array(numOfWeeks)].map((_, i) => {
            const weekNumber = startWeek + i;
            return (
              <div className="form-group" key={i} style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ flex: '1', marginRight: '10px' }}>Tjedan {weekNumber}:</label>
                <input
                  type="number"
                  value={earnings[i]}
                  onChange={(e) => handleEarningChange(e, i)}
                  style={{ flex: '2', marginRight: '10px' }}
                />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteEarning(i)}
                  title="Obriši zaradu"
                  style={{ padding: '5px 10px', fontSize: '14px' }}
                >
                  <FaTrash />
                </button>
              </div>
            );
          })}
          {/* Wolt zarade - W1 i W2 */}
          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '2px solid #e9ecef' }}>
            <h3 style={{ marginBottom: '15px', color: '#667eea' }}>Wolt zarade</h3>
            {[0, 1].map((woltIndex) => (
              <div className="form-group" key={`wolt-${woltIndex}`} style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ flex: '1', marginRight: '10px' }}>W{woltIndex + 1} (Wolt):</label>
                <input
                  type="number"
                  value={woltEarnings[woltIndex]}
                  onChange={(e) => handleWoltEarningChange(e, woltIndex)}
                  style={{ flex: '2', marginRight: '10px' }}
                />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteWoltEarning(woltIndex)}
                  title="Obriši Wolt zaradu"
                  style={{ padding: '5px 10px', fontSize: '14px' }}
                >
                  <FaTrash />
                </button>
              </div>
            ))}
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveEarnings}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeEarningsModal}>Odustani</button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default PersonRow;